export const discordJoinLink = "https://discord.gg/eFNVTn5tY8";
